import React from "react";
import _ from "lodash";

/**
 * -CenterMap-
 * CenterMap component
 **/
class CenterMap extends React.Component {
	state = {
		loading: false,
		location: null,
		moved: false,
		watchPositionId: null,
	};

	applyGeolocation = (location) => {
		const { google } = this.props;

		const lat = location.coords.latitude;
		const lng = location.coords.longitude;

		this.setCenter(lat, lng);

		// Add markers

		// Inner marker (location)
		var inner_circle = {
			path: google.maps.SymbolPath.CIRCLE,
			fillColor: "#4285f4",
			fillOpacity: 1,
			scale: 7,
			strokeColor: "#ffffff",
			strokeWeight: 2,
		};

		const inner_marker = {
			location: {
				lat,
				lng,
			},
			icon: inner_circle,
		};

		// Outer marker
		var outer_circle = {
			path: google.maps.SymbolPath.CIRCLE,
			fillColor: "#4285f4",
			fillOpacity: 0.2,
			scale: 20,
			strokeWeight: 0,
		};

		const outer_marker = {
			location: {
				lat,
				lng,
			},
			icon: outer_circle,
		};

		const markers = [outer_marker, inner_marker];

		this.props.addMarkers("geolocation", markers);

		this.setState({
			loading: false,
		});
	}

	setZoom = () => {
		const { map } = this.props;
		map.setZoom(15);
	}

	setCenter = (lat, lng) => {
		const { map } = this.props;

		const location = { lat: parseFloat(lat), lng: parseFloat(lng) };

		map.setCenter(location);

		this.props.setUserLocation(lat, lng);

		this.setState({
			location,
		});
	};

	followOnMap = () => {
		if (this.state.watchPositionId !== null) {
			navigator.geolocation.clearWatch(this.state.watchPositionId);
		}

		const newWatchPositionId = navigator.geolocation.watchPosition((location) => {
			this.applyGeolocation(location);
			this.setCenter(location.coords.latitude, location.coords.longitude);
		});

		this.setZoom();

		this.setState({
			watchPositionId: newWatchPositionId,
			moved: false,
			loading: true,
		});
	}

	componentDidUpdate(prevProps) {
		const userMoved = !_.isEqual(
			prevProps.currentLocation,
			this.props.currentLocation
		);
		if (userMoved) {
			this.setState({
				moved: true,
			});
		}
	}

	render() {
		return (
			<button
				className={ `center-map ${ this.state.loading ? "is-loading" : "not-loading"
					} hasError-${ this.state.error }` }
				onClick={ (e) => this.followOnMap(e) }
			>
				<span className="assistive-text">Fetch geolocation</span>
				<svg className="icon" aria-hidden="true">
					<use xlinkHref="#geo_location"></use>
				</svg>
			</button>
		);
	}
}

export default CenterMap;



// WEBPACK FOOTER //
// ./src/components/googlemaps/CenterMap.js